var map = {
	"./betting_icon.embedded.svg": 1301,
	"./boxing_icon.embedded.svg": 1302,
	"./champions_league.embedded.svg": 1303,
	"./conmebol_icon.embedded.svg": 1304,
	"./csgo_icon.embedded.svg": 1305,
	"./dfs_icon.embedded.svg": 1306,
	"./dota2_icon.embedded.svg": 1307,
	"./dr_pepper.embedded.svg": 1308,
	"./dreamhack_icon.embedded.svg": 1309,
	"./esl_icon.embedded.svg": 1310,
	"./fifa.embedded.svg": 1311,
	"./fnatic_icon.embedded.svg": 1312,
	"./fortnite.embedded.svg": 1313,
	"./i_league_icon.embedded.svg": 1314,
	"./league-of-legends.embedded.svg": 1315,
	"./logo-12up.embedded.svg": 541,
	"./logo-90min.embedded.svg": 542,
	"./logo-dbltap.embedded.svg": 543,
	"./logo-ei.embedded.svg": 544,
	"./logo-floor8.embedded.svg": 545,
	"./logo-ftb90.embedded.svg": 546,
	"./logo-german_site.embedded.svg": 547,
	"./logo-ht_media.embedded.svg": 548,
	"./logo-pluralist.embedded.svg": 549,
	"./logo-theduel-mobile.embedded.svg": 550,
	"./logo-theduel.embedded.svg": 551,
	"./lol_icon.embedded.svg": 1316,
	"./mdl_icon.embedded.svg": 1317,
	"./melee_icon.embedded.svg": 1318,
	"./mlb_icon.embedded.svg": 1319,
	"./mls_icon.embedded.svg": 1320,
	"./mma_icon.embedded.svg": 1321,
	"./nba_icon.embedded.svg": 1322,
	"./ncaa-basketball_icon.embedded.svg": 1323,
	"./ncaa-football_icon.embedded.svg": 1324,
	"./nfl_icon.embedded.svg": 1325,
	"./nhl_icon.embedded.svg": 1326,
	"./overwatch.embedded.svg": 1327,
	"./overwatch_icon.embedded.svg": 1328,
	"./powered-by-ei.embedded.svg": 552,
	"./powered-by-german_site.embedded.svg": 553,
	"./powered-by-ht_media.embedded.svg": 554,
	"./pubg.embedded.svg": 1329,
	"./smash4_icon.embedded.svg": 1330,
	"./streetfighter_icon.embedded.svg": 1331,
	"./suzuki_cup.embedded.svg": 1332,
	"./theduel-nav.embedded.svg": 1333,
	"./theduel_menu_icon.embedded.svg": 1334,
	"./trending-games.embedded.svg": 1335,
	"./women-football.embedded.svg": 1336,
	"./world-cup.embedded.svg": 1337,
	"./yousport_icon.embedded.svg": 1338
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1350;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1350
// module chunks = 37